export default {
  namespaced: true,
  state: {
    currentAudio: null
  },
  mutations: {
    SET_CURRENT_AUDIO(state, currentAudio) {
      state.currentAudio = currentAudio
    }
  },
  actions: {
  },
  getters: {
  }
}